var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.calc.inputs && _vm.calc.inputs.length > 0)?_c('div',{staticClass:"d-flex mb-3"},[_c('v-layout',{attrs:{"wrap":""}},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }